export { default as AnimatedChartCompact } from "./AnimatedChartCompact";
